import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import { useTheme, Theme } from '@material-ui/core/styles';
import LogoImage from '../../../../../images/icons/logo.png';

const Img = styled.img<{ theme: Theme }>`
  width: 25px;
  height: auto;
  margin-right: ${({ theme }) => theme.spacing(1)};
  vertical-align: middle;
  border-style: none;
`;

interface Props {}
const SPLogo: VFC<Props> = (props: Props) => {
  const theme = useTheme();

  return (
    <Img
      src={LogoImage}
      alt={T.translate('otetsutabi') as string}
      theme={theme}
    />
  );
};

export default SPLogo;
